"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userActivites = exports.updateUserRole = exports.updateRemoveAccessStatus = exports.setUserDetails = exports.setUserData = exports.setUpdateUserRoleStatus = exports.setMinesites = exports.setAssignableUsers = exports.setAppRoleDetails = exports.sendInvitationState = exports.sendInvitation = exports.savePendingAccessRequests = exports.saveMineSiteLabel = exports.saveApplicationBusinessEntities = exports.saveAccessRequestRoles = exports.notificationActions = exports.mineSitesData = exports.handleError = exports.getUsersForSelectedRole = exports.getUsersForSelectedBusinessEntity = exports.getUserActivities = exports.getRolesForSelectedApp = exports.getPendingAccessRequests = exports.getBusinessEntities = exports.getAssignableUsers = exports.getApplicationConfiguredBusinessEntities = exports.getApiToken = exports.getAccessRequestRoles = exports.fetchMineSiteInfoSuccess = exports.fetchMineSiteInfoFailure = exports.fetchMineSiteInfo = exports.deleteUserAccess = exports.approveRejectAccessRequests = exports.appinfo = void 0;
var _actionTypes = require("./actionTypes");
var _msalInstance = _interopRequireDefault(require("../../services/msalInstance"));
var _oneWeir = require("@weirgroup/one-weir");
var _dateFns = require("date-fns");
var _msalConfig = require("../../services/msalConfig");
var _constants = require("./localization/constants");
var _constants2 = require("../../resources/constants");
var _axios = _interopRequireDefault(require("axios"));
var _mock = require("./mock");
var _loader = require("../../loader/loader.actions");
var _constants3 = require("../../shared/_constants");
var _accessRequestconstants = require("./accessRequests/accessRequestconstants");
var _countryList = require("./accessRequests/countryList");
const crypto = require('crypto');
Object.defineProperty(window, 'crypto', crypto);
const setMinesites = data => ({
  type: _actionTypes.ActionTypes.GET_BUSINESSENTITIES,
  payload: data
});
exports.setMinesites = setMinesites;
const updateRemoveAccessStatus = status => dispatch => {
  dispatch({
    type: _actionTypes.ActionTypes.REMOVE_ACCESS,
    payload: status
  });
};
exports.updateRemoveAccessStatus = updateRemoveAccessStatus;
function updateMSALConstants(appId) {
  _msalConfig.msalConfig.auth.redirectUri = "".concat(window.location.origin).concat(window.localStorage.getItem('appName')).concat(_constants3.applicationRouteConstants.MANAGEYOUR_TEAM_PAGE);
  _msalConfig.msalConfig.auth.clientId = appId;
  const msalInstance = new _msalInstance.default(_msalConfig.msalConfig);
  return msalInstance;
}
function getAPIScope() {
  return ['api://885ee620-55e8-438c-a1fe-ed82671a2450/allresources.access.asuser'];
}
const findParentNode = (nodeId, entities) => {
  for (let index = 0; index < entities.length; index++) {
    const currentNode = entities[index];
    if (nodeId.indexOf(currentNode.nodeId) >= 0) {
      const parentNodeId = nodeId.substring(0, nodeId.substring(0, nodeId.length - 1).lastIndexOf('/') + 1);
      if (currentNode.nodeId === parentNodeId) {
        return currentNode;
      }
      const node = findParentNode(nodeId, currentNode.children);
      if (node !== null) {
        return node;
      }
    }
  }
  return null;
};
const getBusinessEntities = (appId, sourceSystemName) => async dispatch => {
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.businessEntitylist.replace('<ApplicationObjectId>', appId);
  let APIURL = appURL.replace('<SourceSystemName>', sourceSystemName);
  const iamsToken = await msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'));
  iamsToken && _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL).concat(APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1.1'
    }
  }).then(response => {
    dispatch(_loader.loaderActions.hide());
    if (response.data !== '') {
      const fullBusinessEntities = response.data.applicationBusinessEntities;
      let filteredBusinessEntities = [];
      const nodeIds = [...new Set(fullBusinessEntities.map(item => item.nodeId))];
      nodeIds.forEach(obj => {
        const currentNodeId = obj;
        let currentNode = fullBusinessEntities.find(x => x.nodeId === currentNodeId);
        currentNode = {
          ...currentNode,
          children: []
        };
        const parentNode = findParentNode(currentNodeId, filteredBusinessEntities);
        if (parentNode === null) {
          filteredBusinessEntities.push(currentNode);
        } else {
          currentNode.children = currentNode.children.sort((a, b) => {
            if (a.sourceSystemBusinessEntityDisplayName > b.sourceSystemBusinessEntityDisplayName) {
              return 1;
            }
            if (a.sourceSystemBusinessEntityDisplayName < b.sourceSystemBusinessEntityDisplayName) {
              return -1;
            }
            return 0;
          });
          parentNode.children.push(currentNode);
        }
      });
      filteredBusinessEntities = filteredBusinessEntities.sort((a, b) => {
        if (a.sourceSystemBusinessEntityDisplayName > b.sourceSystemBusinessEntityDisplayName) {
          return 1;
        }
        if (a.sourceSystemBusinessEntityDisplayName < b.sourceSystemBusinessEntityDisplayName) {
          return -1;
        }
        return 0;
      });
      dispatch(setMinesites(filteredBusinessEntities));
      dispatch(mineSitesData(fullBusinessEntities));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getBusinessEntities = getBusinessEntities;
const setUserData = data => ({
  type: _actionTypes.ActionTypes.GET_USER_DETAILS,
  payload: data
});
exports.setUserData = setUserData;
const setAssignableUsers = data => ({
  type: _actionTypes.ActionTypes.SET_ASSIGNABLE_USERS,
  payload: data
});

/**
 *  Start:
 *  getUsersForSelectedBusinessEntity will get users based up on selection of mine
 *  Params: objectId
*/
exports.setAssignableUsers = setAssignableUsers;
const getUsersForSelectedBusinessEntity = (appId, busEntityID) => dispatch => {
  var _msalInstance$getApiT;
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.getUsersForSelectedBusinessEntityURL.replace('<ApplicationObjectId>', appId);
  let APIURL = appURL.replace('<BusinessEntityObjectId>', busEntityID);
  (_msalInstance$getApiT = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT === void 0 || _msalInstance$getApiT.then(iamsToken => _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (response.data !== '') {
      dispatch(setUserData(response.data));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getUsersForSelectedBusinessEntity = getUsersForSelectedBusinessEntity;
const getAssignableUsers = appId => async dispatch => {
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let APIURL = _constants2.serviceMethodConstants.getAssignableUsers.replace('<applicationObjectId>', appId);
  const iamsToken = await msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'));
  iamsToken && _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  }).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (response.data !== '') {
      dispatch(setAssignableUsers(response.data));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getAssignableUsers = getAssignableUsers;
const setAppRoleDetails = roleList => ({
  type: _actionTypes.ActionTypes.GET_ROLES_FOR_APP,
  payload: roleList
});

/**
 * Start:
 * TO get the Apps and Roles details
 */
exports.setAppRoleDetails = setAppRoleDetails;
const getRolesForSelectedApp = appId => async dispatch => {
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  const iamsToken = await msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'));
  iamsToken && _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL + _constants2.serviceMethodConstants.userRolesList.replace('<ApplicationObjectId>', appId)), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  }).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (response.data !== '') {
      dispatch(setAppRoleDetails(response.data.appRoles));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getRolesForSelectedApp = getRolesForSelectedApp;
const setUpdateUserRoleStatus = status => ({
  type: _actionTypes.ActionTypes.UPDATE_USER_ROLE,
  payload: status
});

/* update user role */
exports.setUpdateUserRoleStatus = setUpdateUserRoleStatus;
const updateUserRole = reqBody => dispatch => {
  var _msalInstance$getApiT2;
  const msalInstance = updateMSALConstants(reqBody.applicationID);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.updateAppRoleForBusinessEntity.replace('<ApplicationObjectId>', reqBody.applicationID);
  let busURL = appURL.replace('<BusinessEntityObjectId>', reqBody.businessEntityObjectId);
  let appRoleURL = busURL.replace('<ApplicationRoleObjectId>', reqBody.updatedAppRoleId);
  let APIURL = appRoleURL.replace('<UserObjectId>', reqBody.userObjectId);
  (_msalInstance$getApiT2 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT2 === void 0 || _msalInstance$getApiT2.then(iamsToken => _axios.default.put("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {}, {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (response.status === 200) {
      _oneWeir.toastStatus.success('Access has been updated successfully');
      dispatch(getUsersForSelectedBusinessEntity(reqBody.applicationID, reqBody.businessEntityObjectId));
      dispatch(fetchMineSiteInfo(reqBody.appInfo, reqBody.userObjectId));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};

/**
 * Start:
 * To Remove User accsess.
 */
exports.updateUserRole = updateUserRole;
const deleteUserAccess = (applicationID, deleteUserData, businessDataObj) => dispatch => {
  var _msalInstance$getApiT3;
  const msalInstance = updateMSALConstants(applicationID);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.updateAppRoleForBusinessEntity.replace('<ApplicationObjectId>', applicationID);
  let busURL = appURL.replace('<BusinessEntityObjectId>', businessDataObj.businessEntityObjectId);
  let appRoleURL = busURL.replace('<ApplicationRoleObjectId>', deleteUserData.MineSiteUserappRoleObjectId.source);
  let APIURL = appRoleURL.replace('<UserObjectId>', deleteUserData.MineSiteUserObjectId.source);
  (_msalInstance$getApiT3 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT3 === void 0 || _msalInstance$getApiT3.then(iamsToken => _axios.default.delete("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (response.status === 200) {
      _oneWeir.toastStatus.success('Access has been removed successfully');
      dispatch(getUsersForSelectedBusinessEntity(applicationID, businessDataObj.businessEntityObjectId));
      deleteUserData.appInfo && deleteUserData.userObjectId && dispatch(fetchMineSiteInfo(deleteUserData.appInfo, deleteUserData.userObjectId));
    }
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.deleteUserAccess = deleteUserAccess;
const sendInvitationState = state => ({
  type: _actionTypes.ActionTypes.SEND_INVITATION_STATE,
  sendInvitationState: state
});
exports.sendInvitationState = sendInvitationState;
const appinfo = appinfo => ({
  type: _actionTypes.ActionTypes.SET_APP_ID,
  payload: appinfo
});
exports.appinfo = appinfo;
const sendInvitation = data => dispatch => {
  var _msalInstance$getApiT4;
  const msalInstance = updateMSALConstants(data.AppObjectId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.sendInviteUrl.replace('<applicationObjectId>', data.AppObjectId);
  let busURL = appURL.replace('<BusinessEntityObjectId>', data.BusinessEntityObjectId);
  let appRoleURL = busURL.replace('<ApplicationRoleObjectId>', data.AppRoleId);
  let APIURL = appRoleURL.replace('<UserEmail>', data.UserEmail);
  (_msalInstance$getApiT4 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT4 === void 0 || _msalInstance$getApiT4.then(iamsToken => _axios.default.post("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {}, {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(() => {
    dispatch(_loader.loaderActions.hide(dispatch));
    _oneWeir.toastStatus.success("".concat(data.UserEmail, ": ").concat(_constants.manageYourTeamConstants.SEND_INVITATION_TOAST_MESSAGE));
    dispatch(sendInvitationState(true));
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    _oneWeir.toastStatus.error('Something went wrong', {
      onClose: () => dispatch(sendInvitationState(true))
    });
  });
};
exports.sendInvitation = sendInvitation;
const setUserDetails = usersData => ({
  type: _actionTypes.ActionTypes.GET_USERS_FOR_ROLE,
  payload: usersData
});

/**
 * Start:
 * To get list of users for selected app
 */
exports.setUserDetails = setUserDetails;
const getUsersForSelectedRole = appId => dispatch => {
  var _msalInstance$getApiT5;
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  (_msalInstance$getApiT5 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT5 === void 0 || _msalInstance$getApiT5.then(iamsToken => _axios.default.get("".concat(_constants2.serviceMethodConstants.activities), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(() => {
    dispatch(_loader.loaderActions.hide(dispatch));
    dispatch(setUserDetails(_mock.usersData));
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    dispatch(setUserDetails(_mock.usersData));
  });
};
exports.getUsersForSelectedRole = getUsersForSelectedRole;
const mineSitesData = data => ({
  type: _actionTypes.ActionTypes.GET_MINESITES,
  payload: data
});
exports.mineSitesData = mineSitesData;
const getUserActivities = (data, appId) => dispatch => {
  var _msalInstance$getApiT6;
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appURL = _constants2.serviceMethodConstants.getUserActivity.replace('<applicationObjectId>', appId);
  let APIURL = appURL.replace('<userObjectId>', data.MineSiteUserObjectId.value);
  (_msalInstance$getApiT6 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT6 === void 0 || _msalInstance$getApiT6.then(iamsToken => _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    dispatch(userActivites(response.data));
  }).catch(err => {
    dispatch(_loader.loaderActions.hide(dispatch));
    if (err.response !== undefined) {
      _oneWeir.toastStatus.error(err.response.statusText);
    }
  });
};
exports.getUserActivities = getUserActivities;
const userActivites = data => ({
  type: _actionTypes.ActionTypes.GET_USERACTIVITIES,
  payload: data
});
exports.userActivites = userActivites;
const savePendingAccessRequests = pendingAccessRequests => ({
  type: _accessRequestconstants.CONSTANTS.SAVE_PENDING_ACCESS_REQUESTS,
  payload: pendingAccessRequests
});
exports.savePendingAccessRequests = savePendingAccessRequests;
const saveAccessRequestRoles = accessRequestRoles => ({
  type: _accessRequestconstants.CONSTANTS.SAVE_ACCESS_REQUEST_ROLES,
  payload: accessRequestRoles
});
exports.saveAccessRequestRoles = saveAccessRequestRoles;
const saveApplicationBusinessEntities = businessentities => ({
  type: _accessRequestconstants.CONSTANTS.SAVE_APPLICATION_BUSINESS_ENTITIES,
  payload: businessentities
});
exports.saveApplicationBusinessEntities = saveApplicationBusinessEntities;
const handleSuccess = dispatch => action => response => {
  dispatch(_loader.loaderActions.hide());
  dispatch(action(response));
};
const handleError = dispatch => err => {
  dispatch(_loader.loaderActions.hide());
  serviceFactory.apiErrorHandle(err, dispatch);
};
exports.handleError = handleError;
const getApiToken = appId => {
  const msalInstance = updateMSALConstants(appId);
  const scope = getAPIScope();
  return msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'));
};
exports.getApiToken = getApiToken;
const httpGet = (url, appId) => {
  var _getApiToken;
  return (_getApiToken = getApiToken(appId)) === null || _getApiToken === void 0 ? void 0 : _getApiToken.then(iamsToken => _axios.default.get(url, {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  }));
};
const getAccessRequestRoles = (dispatch, baseAppId) => appObjectId => {
  dispatch(_loader.loaderActions.show(dispatch));
  const appendUrl = _constants2.serviceMethodConstants.accessRequestRoles.replace('{appObjectId}', appObjectId);
  httpGet("".concat(_constants2.serviceMethodConstants.sharedApisBaseUrl).concat(appendUrl), baseAppId).then(res => ({
    [appObjectId]: res.data
  })).then(handleSuccess(dispatch)(saveAccessRequestRoles)).catch(handleError(dispatch));
};
exports.getAccessRequestRoles = getAccessRequestRoles;
const getPendingAccessRequests = (dispatch, appId) => {
  var _httpGet;
  dispatch(_loader.loaderActions.show(dispatch));
  const appendUrl = _constants2.serviceMethodConstants.pendingApplicationAccessRequests.replace('{appObjectId}', appId);
  (_httpGet = httpGet("".concat(_constants2.serviceMethodConstants.sharedApisBaseUrl).concat(appendUrl), appId)) === null || _httpGet === void 0 || _httpGet.then(res => {
    let pendingList = (res.data || []).sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
    pendingList = pendingList.map(obj => {
      let countryValue = _countryList.countryList.find(o => o.value === obj.country);
      const addedOnDate = obj.addedOn ? (0, _dateFns.format)(new Date(obj.addedOn), 'dd MMM yyyy hh:mm') : '';
      return {
        ...obj,
        country: countryValue ? countryValue.name : '',
        addedOn: addedOnDate
      };
    });
    return pendingList;
  }).then(handleSuccess(dispatch)(savePendingAccessRequests)).catch(handleError(dispatch));
};
exports.getPendingAccessRequests = getPendingAccessRequests;
const getApplicationConfiguredBusinessEntities = (dispatch, baseAppId) => appObjectId => {
  dispatch(_loader.loaderActions.show(dispatch));
  const appendUrl = _constants2.serviceMethodConstants.applicationBusinessEntities.replace('{appObjectId}', appObjectId);
  httpGet("".concat(_constants2.serviceMethodConstants.sharedApisBaseUrl).concat(appendUrl), baseAppId).then(res => {
    if (res.data) {
      return {
        [appObjectId]: res.data
      };
    }
  }).then(handleSuccess(dispatch)(saveApplicationBusinessEntities)).catch(handleError(dispatch));
};
exports.getApplicationConfiguredBusinessEntities = getApplicationConfiguredBusinessEntities;
const approveRejectAccessRequests = (dispatch, clearSelection, appId) => payload => {
  var _msalInstance$getApiT7;
  const msalInstance = updateMSALConstants(appId);
  dispatch(_loader.loaderActions.show(dispatch));
  const appendUrl = _constants2.serviceMethodConstants.approveRejectAccessRequests.replace('{appObjectId}', appId);
  const scope = getAPIScope();
  (_msalInstance$getApiT7 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT7 === void 0 || _msalInstance$getApiT7.then(iamsToken => _axios.default.post("".concat(_constants2.serviceMethodConstants.sharedApisBaseUrl).concat(appendUrl), payload, {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(res => {
    dispatch(_loader.loaderActions.hide());
    const rejectedCount = res.data.filter(x => x.status === _accessRequestconstants.CONSTANTS.REJECTED).length;
    const acceptedCount = res.data.filter(x => x.status === _accessRequestconstants.CONSTANTS.ACCEPTED).length;
    let notificationMessage = '';
    if (acceptedCount > 0 && rejectedCount === 0) {
      notificationMessage = "".concat(_accessRequestconstants.CONSTANTS.APPROVED_SUCCESS_MESSAGE).replace('{approvedCount}', acceptedCount);
    } else if (acceptedCount === 0 && rejectedCount > 0) {
      notificationMessage = "".concat(_accessRequestconstants.CONSTANTS.REJECTED_SUCCESS_MESSAGE).replace('{rejectedCount}', rejectedCount);
    } else {
      notificationMessage = "".concat(_accessRequestconstants.CONSTANTS.APPROVED_REJECTED_SUCCESS_MESSAGE).replace('{rejectedCount}', rejectedCount).replace('{approvedCount}', acceptedCount);
    }
    clearSelection();
    getPendingAccessRequests(dispatch, appId);
    dispatch(notificationActions.showNotification({
      notificationType: _accessRequestconstants.CONSTANTS.MESSAGE,
      notificationTitle: _accessRequestconstants.CONSTANTS.SUBMIT_SUCCESS,
      notificationMessage
    }));
  }).catch(err => {
    dispatch(_loader.loaderActions.hide());
    serviceFactory.apiErrorHandle(err, dispatch);
  });
};

/**
 * To fetch information related to each user mapped to mine site
 * @param  appInfo 
 * @param  userId 
 */
exports.approveRejectAccessRequests = approveRejectAccessRequests;
const fetchMineSiteInfo = (appInfo, userId) => dispatch => {
  var _msalInstance$getApiT8;
  const msalInstance = updateMSALConstants(appInfo.appid);
  dispatch(_loader.loaderActions.show(dispatch));
  let scope = getAPIScope();
  let appID = _constants2.serviceMethodConstants.fetchMineSiteInfo.replace('<applicationObjectId>', appInfo.appid);
  let userObjectId = appID.replace('<userObjectId>', userId);
  let APIURL = userObjectId.replace('<sourceSystemName>', appInfo.srouceSystem);
  (_msalInstance$getApiT8 = msalInstance.getApiToken(scope, window.localStorage.getItem('UserName'))) === null || _msalInstance$getApiT8 === void 0 || _msalInstance$getApiT8.then(iamsToken => _axios.default.get("".concat(_constants2.serviceMethodConstants.baseURL + APIURL), {
    mode: 'no-cors',
    headers: {
      Authorization: "Bearer ".concat(iamsToken),
      Accept: 'application/json; application/vnd.weir-iamservice.v1'
    }
  })).then(response => {
    dispatch(_loader.loaderActions.hide(dispatch));
    dispatch(fetchMineSiteInfoSuccess(response.data));
  }).catch(error => {
    dispatch(_loader.loaderActions.hide(dispatch));
    dispatch(fetchMineSiteInfoFailure(error));
  });
};
exports.fetchMineSiteInfo = fetchMineSiteInfo;
const fetchMineSiteInfoSuccess = data => ({
  type: _actionTypes.ActionTypes.FETCH_MINE_SITE_INFO_SUCCESS,
  response: data
});
exports.fetchMineSiteInfoSuccess = fetchMineSiteInfoSuccess;
const fetchMineSiteInfoFailure = data => ({
  type: _actionTypes.ActionTypes.FETCH_MINE_SITE_INFO_FAILURE,
  error: data
});
exports.fetchMineSiteInfoFailure = fetchMineSiteInfoFailure;
const hideNotification = () => ({
  type: _actionTypes.ActionTypes.HIDE_NOTIFICATION
});
const showNotification = payload => ({
  type: _actionTypes.ActionTypes.SHOW_NOTIFICATION,
  payload
});
const notificationActions = exports.notificationActions = {
  hideNotification,
  showNotification
};
const saveMineSiteLabel = data => ({
  type: _actionTypes.ActionTypes.SAVE_MINE_SITE_LABEL,
  payload: data
});
exports.saveMineSiteLabel = saveMineSiteLabel;